import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";
import { getAccountIsPersonal, getToken } from "../lib/auth";
import { useIsEdgeRestricted } from "../hooks/useEdgeMode";
import SharedAccountGate from "./SharedAccountGate";

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const token = getToken();
  // Ограничен локален режим (§14.3.1, docs/edge.md): терминалът работи срещу
  // касата, но билетът му е изтекъл, докато е бил изгасен — през касата
  // минават само двата login-а, затова никой модул не се отваря. Личният
  // акаунт влиза наново с парола на екрана за вход (той праща към касата),
  // общият терминал — с код на ПИН екрана (гейтът отдолу).
  //
  // Общият НЕ се праща към `/login` автоматично: там се иска парола на
  // ТЕРМИНАЛА, а нормалният му път навън е кодът. Пътят до „потребител и
  // парола" за него е бутонът на самия ПИН екран (`CodeKeypad.tsx`) — иначе
  // терминал без работещ код нямаше как да стигне дотам изобщо.
  const edgeRestricted = useIsEdgeRestricted();
  if (!token) return <Navigate to="/login" replace />;
  if (edgeRestricted && getAccountIsPersonal() !== false)
    return <Navigate to="/login" replace />;
  // Акаунт за общ достъп изисква пин преди достъп до който и да е модул.
  // Личният акаунт минава директно през гейта.
  return <SharedAccountGate>{children}</SharedAccountGate>;
}
